/** NOTIF1 T17: Accueil search bar + Ctrl/⌘K palette copy. */
export const SEARCH_COPY = Object.freeze({
  placeholder: 'Rechercher un élève, une facture, une action…',
  shortPlaceholder: 'Rechercher…',
  dialogLabel: 'Recherche',
  inputLabel: 'Rechercher',
  close: 'Fermer',
  kbdApple: '⌘ K',
  kbdOther: 'Ctrl K',
  noResult: 'Aucun résultat.',
  groups: {
    quick: 'Actions rapides',
    recents: 'Récents',
    proposals: 'Propositions',
    students: 'Élèves',
    families: 'Familles',
    invoices: 'Factures',
    pages: 'Pages',
  },
  quick: {
    startCourse: 'Démarrer un cours',
    addStudent: 'Inscrire un élève',
    recordPayment: 'Enregistrer un paiement',
    declareUrssaf: 'Déclarer à l’URSSAF',
  },
  pages: {
    home: 'Accueil',
    students: 'Élèves',
    families: 'Familles',
    payments: 'Paiements',
    invoices: 'Factures',
    statistics: 'Statistiques',
    schedules: 'Agenda',
    notifications: 'Notifications',
    settings: 'Paramètres',
    tools: 'Outils',
  },
  familyOf: (name) => `Famille ${name}`,
});
